import React from "react";
import "./FloatButton.scss";
import { Link, useLocation } from "react-router-dom";
import { performConversionScript } from "../../../shared/ConversionHelper";

interface FloatButtonProps {
  message?: string;
  ctaText?: string;
  ctaPath?: string;
}

const DEFAULT_MESSAGE = "세이브오피스로 비즈니스의 신뢰도를 높여보세요.";
const DEFAULT_CTA_TEXT = "빠른 상담하기";
const DEFAULT_CTA_PATH = "/consult";

const FloatButton = ({
  message = DEFAULT_MESSAGE,
  ctaText = DEFAULT_CTA_TEXT,
  ctaPath = DEFAULT_CTA_PATH,
}: FloatButtonProps) => {
  const [visible, setVisible] = React.useState(false);
  const buttonRef = React.useRef<any>(null);
  const location = useLocation();

  React.useEffect(() => {
    let scrollY = 0;
    function isVisible() {
      if (window.scrollY > scrollY) {
        setVisible(true);
        scrollY = window.scrollY;
      } else {
        setVisible(false);
        scrollY = window.scrollY;
      }
    }

    window.addEventListener("scroll", isVisible);
    return () => window.removeEventListener("scroll", isVisible);
  }, []);

  return (
    <div className={`float-button-container ${visible ? "visible" : ""}`}>
      <div className="float-button-wrapper">
        <p>{message}</p>
        <Link
          to={`${ctaPath}${location.search}`}
          onClick={performConversionScript}
        >
          <button className="float-button" ref={buttonRef}>
            {ctaText}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default FloatButton;
